import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Avatar,
    Box,
    Card,
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Typography,
    Button,
    TextField,              
    InputAdornment,         
    IconButton              
} from '@mui/material';
import { apiUrl } from "../../constants";
import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import EditNoteIcon from '@mui/icons-material/EditNote';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';   
import { useSelector } from 'react-redux';
import useCheckToken from '../../hooks/useCheckToken';
import useExchangeToken from "../../hooks/useExchangeToken";
import { formatWipDuration } from '../../utils/wipDuration';
import { WIP_FIELDS } from './WipMasterForm';

const MySwal = withReactContent(Swal);

function StandardSettingList({ customers, isWipPlant = false, editBase = '/edit-master-std', ...rest }) {
    const ScrollContainer = isWipPlant ? Box : PerfectScrollbar;
    const exchangeToken = useExchangeToken();
    const navigate = useNavigate();
    const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [deleteButton, setDeleteButton] = useState(false);
    const [deleteNumber, setdeleteNumber] = useState(0);
    const [idUser, setId] = useState();
    const [status, setStatus] = useState('');
    const [select, setSelect] = useState();
    const [isTokenExchanged, setIsTokenExchanged] = useState(false);
    const [error, setError] = useState(null);


    const [skuQuery, setSkuQuery] = useState('');
    const [committedSku, setCommittedSku] = useState(''); 

    useCheckToken();
    const ac_token = useSelector(state => state.auth.access_token);

    useEffect(() => {
        const fetchMyAPI = async () => {
            try {
                await exchangeToken(); 
                const id = new URL(window.location.href).searchParams.get("id");
                if (isWipPlant) return;
                const url = `${apiUrl.USER}${id}/`;
                const result = await axios.get(url, {
                    headers: { Authorization: `Bearer ${ac_token}` }
                });
                // setValues(result.data);
            } catch (error) {
                console.error("Error fetching or exchanging token:", error);
                setError("Failed to fetch user data");
            }
        };

        fetchMyAPI();
    }, [ac_token, exchangeToken, isWipPlant]);

    const norm = (v) => (v ?? '').toString().toLowerCase();

    const wipColumns = [['plant_id', 'Plant'], ['factory', 'Factory'], ...WIP_FIELDS.filter(([key]) => !key.endsWith('_unit') || key === 'storage_unit'), ['weight', 'Weight'], ['qty', 'Qty']];

    const filteredCustomers = useMemo(() => {
        if (!committedSku) return customers;
        const q = norm(committedSku);
        return customers.filter(c => (isWipPlant
            ? [c.product_code, c.product_name, c.product_group, c.ingredient]
            : [c.material_description, c.sku, c.material_code]
        ).some(v => norm(v).includes(q)));
    }, [customers, committedSku, isWipPlant]);

    useEffect(() => {
        setSelectedCustomerIds([]);
        setDeleteButton(false);
        setdeleteNumber(0);
        setId([]);
        setPage(0); 
    }, [committedSku]);

    const handleSelectAll = (event) => {
        let newSelectedCustomerIds;

        const source = filteredCustomers; 
        if (event.target.checked) {
            newSelectedCustomerIds = source.map((customer) => customer.id);
            setDeleteButton(true);
            setdeleteNumber(newSelectedCustomerIds.length);
            setId(newSelectedCustomerIds);
        } else {
            newSelectedCustomerIds = [];
            setDeleteButton(false);
            setId(newSelectedCustomerIds);
        }
        setSelectedCustomerIds(newSelectedCustomerIds);
    };

    const handleSelectOne = (event, id) => {
        const selectedIndex = selectedCustomerIds.indexOf(id);
        let newSelectedCustomerIds = [];
        if (selectedIndex === -1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds,
                id
            );
            setDeleteButton(true);
            setdeleteNumber(newSelectedCustomerIds.length);
            setId(newSelectedCustomerIds);
        } else if (selectedIndex === 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds.slice(1)
            );
            if (newSelectedCustomerIds.length == 0) {
                setDeleteButton(false);
            } else {
                setDeleteButton(true);
                setId();
                setdeleteNumber(newSelectedCustomerIds.length);
            }
        } else if (selectedIndex === selectedCustomerIds.length - 1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds.slice(0, -1)
            );
            setDeleteButton(true);
            setId(newSelectedCustomerIds);
            setdeleteNumber(newSelectedCustomerIds.length);
        } else if (selectedIndex > 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds.slice(0, selectedIndex),
                selectedCustomerIds.slice(selectedIndex + 1)
            );
            setDeleteButton(true);
            setId();
            setdeleteNumber(newSelectedCustomerIds.length);
        }

        setSelectedCustomerIds(newSelectedCustomerIds);
    };

    const handleLimitChange = (event) => {
        setLimit(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleDelete = async () => {
        if (isWipPlant && !selectedCustomerIds.length) return;
        MySwal.fire({
            title: 'Are you sure to delete?',
            text: "You won't be able to revert this!",
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            didOpen: () => {
                const confirmButton = document.querySelector('.swal2-confirm');
                const cancelButton = document.querySelector('.swal2-cancel');

                if (confirmButton) {
                    confirmButton.style.fontFamily = 'CPF_Imm_Sook';
                    confirmButton.style.fontSize = '20px';
                }
                if (cancelButton) {
                    cancelButton.style.fontFamily = 'CPF_Imm_Sook';
                    cancelButton.style.fontSize = '20px';
                }
            }
        }).then(async (result) => {
            if (result.value) {
                try {
                    for (let i = 0; i < selectedCustomerIds.length; i++) {
                        const selectedId = selectedCustomerIds[i];
                        const selectedRow = filteredCustomers.find(row => row.id === selectedId);
                        const deleteUrl = isWipPlant
                            ? `${apiUrl.WIP_TRACKING}${selectedId}/`
                            : `${apiUrl.GET_MASTER_STD}delete/${selectedRow?.check_on}/`;
                        var result = await axios.delete(deleteUrl, {
                            headers: {
                                Authorization: `Bearer ${ac_token}`,
                            }
                        })
                    }
                    if (result.status >= 200 && result.status < 300) {
                        MySwal.fire({
                            title: 'Done!',
                            text: 'Successfully deleted master standard.',
                            icon: 'success',
                            confirmButtonText: 'Ok,Got it!',
                            didOpen: () => {
                                const confirmButton = document.querySelector('.swal2-confirm');
                                if (confirmButton) {
                                    confirmButton.style.fontFamily = 'CPF_Imm_Sook';
                                    confirmButton.style.fontSize = '20px';
                                }
                            }
                        }).then(() => {
                            window.location.reload(true);
                        });
                    } else {
                        MySwal.fire({
                            title: 'Error!',
                            text: 'Can not delete this master standard.',
                            icon: 'error',
                            confirmButtonText: 'Ok,Got it!',
                            didOpen: () => {
                                const confirmButton = document.querySelector('.swal2-confirm');
                                if (confirmButton) {
                                    confirmButton.style.fontFamily = 'CPF_Imm_Sook';
                                    confirmButton.style.fontSize = '20px';
                                }
                            }
                        });
                    }
                } catch (error) {
                    console.error('Error deleting master standard:', error);
                    await MySwal.fire({
                        title: 'Error!',
                        text: error.response?.data?.detail || 'Can not delete this master standard.',
                        icon: 'error',
                        confirmButtonText: 'Ok,Got it!',
                        didOpen: () => {
                            const button = document.querySelector('.swal2-confirm');
                            if (button) {
                                button.style.fontFamily = 'CPF_Imm_Sook';
                                button.style.fontSize = '20px';
                            }
                        }
                    });
                }
            } else {
                // cancelled
            }
        });
    };

    const doSearch = () => setCommittedSku(skuQuery.trim());
    const clearSearch = () => {
        setSkuQuery('');
        setCommittedSku('');
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            doSearch();
        }
    };

    return (
        <Card {...rest} sx={isWipPlant ? {
            p: { xs: 1, md: 1.5 }, borderRadius: 2, boxShadow: 'none', border: '1px solid #ecf0f0',
            '& .MuiTableCell-root': { fontSize: 18, py: 1, px: 1.5 },
            '& .MuiTableCell-head': { bgcolor: '#00bfa5', color: '#fff', fontSize: 18, fontWeight: 600 },
            '& .MuiTableHead-root .MuiCheckbox-root': { color: '#fff' },
            '& .MuiTablePagination-root': { borderTop: '1px solid #ecf0f0' },
            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': { fontSize: 18 },
        } : undefined}>
            {isWipPlant && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, px: 1, py: 0.5 }}>
                <Typography component="h2" sx={{ fontSize: 22, color: '#00B3BD' }}>รายการ Master</Typography>
                <Typography sx={{ fontSize: 18, color: 'text.secondary' }}>{filteredCustomers.length} รายการ</Typography>
            </Box>}
            <Box
                sx={{ width: '100%', backgroundColor: isWipPlant ? '#ffecef' : 'pink', p: 1, borderRadius: 1 }}
                style={{ display: deleteButton ? 'block' : 'none' }}
            >
                <Button style={{ color: 'white', backgroundColor: 'red' }} onClick={handleDelete}>
                    Delete
                </Button>
                <Button style={{ color: 'red' }}>
                    &nbsp;&nbsp;{isWipPlant ? selectedCustomerIds.length : deleteNumber} rows Selected
                </Button>
            </Box>

            <Box sx={{ p: isWipPlant ? 1 : 2, display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                <TextField
                    variant="outlined"
                    size="small"
                    label={isWipPlant ? 'ค้นหาสินค้า' : 'ค้นหา SKU'}
                    //placeholder="พิมพ์ SKU แล้วกด Enter หรือปุ่มค้นหา"
                    placeholder={isWipPlant ? 'รหัสหรือชื่อสินค้า' : 'ชื่อ SKU'}
                    value={skuQuery}
                    onChange={(e) => {
                        setSkuQuery(e.target.value);
                        if (isWipPlant) setCommittedSku(e.target.value.trim());
                    }}
                    onKeyDown={handleKeyDown}
                    sx={{
                        ...(isWipPlant ? { flex: 1, minWidth: 0, '& .MuiOutlinedInput-root': { minHeight: 46, bgcolor: '#fff' } } : {}),
                        "& .MuiOutlinedInput-input": {
                            color: "#000000",
                            fontFamily: 'CPF_Imm_Sook',
                            //fontWeight: "bold",
                            fontSize: 18
                        },
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                        endAdornment: skuQuery ? (
                            <InputAdornment position="end">
                                <IconButton aria-label="clear search" size="small" onClick={clearSearch}>
                                    <ClearIcon />
                                </IconButton>
                            </InputAdornment>
                        ) : null
                    }}
                    style={isWipPlant ? { minWidth: 0, width: '100%' } : { minWidth: 320 }}
                />
                {!isWipPlant && <Button
                    variant="contained"
                    color="primary"
                    startIcon={<SearchIcon />}
                    onClick={doSearch}
                >
                    ค้นหา
                </Button>}
                {!isWipPlant && committedSku && (
                    <Typography >
                        แสดงผลสำหรับคำค้น: <b>{committedSku}</b> ({filteredCustomers.length} รายการ)
                    </Typography>
                )}
            </Box>

            <ScrollContainer>
                <Box sx={{ width: '100%', ...(isWipPlant ? { maxHeight: '65vh', minHeight: 0 } : { height: '680px' }), display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{ ...(isWipPlant ? { minHeight: 0, border: '1px solid #e1e1e1', borderRadius: 1.1 } : { flexGrow: 1 }), overflow: 'auto' }}>
                        <Table stickyHeader aria-label="standard setting table">
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        padding="checkbox"
                                        sx={{
                                            minWidth: 60,
                                            backgroundColor: '#f5f5f5',
                                            position: 'sticky',
                                            top: 0,
                                            zIndex: 2
                                        }}
                                    >
                                        <Checkbox
                                            checked={
                                                filteredCustomers.length > 0 &&
                                                selectedCustomerIds.length === filteredCustomers.length
                                            }
                                            color="primary"
                                            indeterminate={
                                                selectedCustomerIds.length > 0 &&
                                                selectedCustomerIds.length < filteredCustomers.length
                                            }
                                            onChange={handleSelectAll}
                                        />
                                    </TableCell>
                                    {(isWipPlant ? [...wipColumns.map(([, label]) => label), "Action"] : [
                                        "Plant", "Factory", "Line", "SKU", "Production Capacity(kg/hr)", "MTH-Std.Pack(g)", "MTH-Upper Limit(g)",
                                        "MTH-Target Giveaway(%)", "MTH-Setting Pack(g)", "MTH-Upper Weight(g)", "MTH-Range Speed(Pack/min)",
                                        "MTH DF Weight(g)", "Absorb range(%)", "Meat yield range(%)", "Avg. Absorb(%)", "Avg. Meat yield(%)",
                                        "Box Weight(kg/box)", "Number of bags/box", "w/pc(Range)", "w/pc", "Action"
                                    ]).map((label, idx) => (
                                        <TableCell
                                            key={idx}
                                            sx={{
                                                fontSize: 14,
                                                fontWeight: 'bold',
                                                minWidth: 120,
                                                backgroundColor: '#f5f5f5',
                                                position: 'sticky',
                                                top: 0,
                                                zIndex: 1,
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            {label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {filteredCustomers.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={isWipPlant ? wipColumns.length + 2 : 22} align="center">
                                            {committedSku ? 'ไม่พบข้อมูลที่ตรงกับคำค้น' : 'No data available'}
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    filteredCustomers
                                        .slice(page * limit, limit === -1 ? filteredCustomers.length : page * limit + limit)
                                        .map((customer) => (
                                            <TableRow
                                                hover
                                                key={customer.id}
                                                selected={selectedCustomerIds.indexOf(customer.id) !== -1}
                                            >
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={selectedCustomerIds.indexOf(customer.id) !== -1}
                                                        onChange={(event) => handleSelectOne(event, customer.id)}
                                                        value="true"
                                                        onClick={() => setSelect({ check_on: customer.check_on })}
                                                    />
                                                </TableCell>
                                                {(isWipPlant ? wipColumns.map(([key]) => {
                                                    if (['time_step', 'use_within', 'shelf_life'].includes(key)) return formatWipDuration(customer[key], customer[`${key}_unit`]);
                                                    const value = customer[key];
                                                    return typeof value === 'boolean' ? (value ? 'Yes' : 'No') : (value ?? '-');
                                                }) : [
                                                    customer.plant_id,
                                                    customer.factory,
                                                    customer.line,
                                                    customer.material_description,
                                                    customer.belt_scale_feed_rate,
                                                    customer.multihead_auto_pack,
                                                    customer.multihead_upper_limit,
                                                    customer.multihead_target_giveaway,
                                                    customer.multihead_target_pack,
                                                    customer.multihead_upper_weight,
                                                    customer.multihead_speed_target,
                                                    customer.multihead_df_weight,
                                                    customer.fg_std_percent_absorb_range,
                                                    customer.fg_std_percent_meat_yield_range,
                                                    customer.fg_std_percent_absorb,
                                                    customer.fg_std_percent_meat_yield,
                                                    customer.fg_kg_per_box,
                                                    customer.fg_bag_per_box,
                                                    customer.weight_per_piece_range,
                                                    customer.weight_per_piece,
                                                    <EditNoteIcon
                                                        onClick={() => navigate(`/edit-master-std?id=${customer.id}`, { replace: true })}
                                                        style={{ fontSize: 22, cursor: 'pointer' }}
                                                    />
                                                ]).map((val, idx) => (
                                                    <TableCell
                                                        key={idx}
                                                        sx={{
                                                            fontSize: 14,
                                                            minWidth: 120,
                                                            whiteSpace: 'nowrap',
                                                        }}
                                                    >
                                                        {val}
                                                    </TableCell>
                                                ))}
                                                {isWipPlant && <TableCell>
                                                    <IconButton aria-label="Edit" onClick={() => navigate(`${editBase}?id=${customer.id}`)}><EditNoteIcon /></IconButton>
                                                </TableCell>}
                                            </TableRow>
                                        ))
                                )}
                            </TableBody>
                        </Table>
                    </Box>
                </Box>
            </ScrollContainer>
            <TablePagination
                component="div"
                count={filteredCustomers.length}   
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleLimitChange}
                page={page}
                rowsPerPage={limit}
                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
            />
        </Card>
    );
}

StandardSettingList.propTypes = {
    customers: PropTypes.array.isRequired,
    isWipPlant: PropTypes.bool
};

export default StandardSettingList;
